import PropTypes from 'prop-types';
import { decode } from 'html-entities';

import CorusImage from '../CorusImage/CorusImage';
import VmsVideo from '../video/VmsVideo/VmsVideo';
import FallbackImage from '../../inline-images/post-fallback-image.jpg';

export default function ArticleFeature(props) {
	const {
		content: article,
	} = props;

	const featuredImageCaption = (
		<figcaption className="wp-caption-text article-featured-image-caption">
			{decode(article.featuredImage?.node?.caption)}
		</figcaption>
	);

	const width = article?.featuredImage?.node?.mediaDetails?.width
		|| 920;
	const height = article?.featuredImage?.node?.mediaDetails?.height
		|| 613;

	const featuredImage = (
		<figure className="article-featured-image-wrapper">
			<CorusImage
				src={article.featuredImage ? article.featuredImage.node?.sourceUrl : FallbackImage.src}
				alt={article.featuredImage ? article.featuredImage.node?.altText : 'Flavour Network'}
				title={article.featuredImage?.node?.title}
				width={width}
				height={height}
				sizes={[574, 704, 582, 856, 856]}
			/>
			{featuredImageCaption}
		</figure>
	);

	return (
		<>
			{
				(article.additionalDetails?.featuredVideoId
				&& <VmsVideo id={article.additionalDetails.featuredVideoId} fallback={featuredImage} />)
				|| featuredImage
			}
		</>
	);
}

ArticleFeature.propTypes = {
	content: PropTypes.object.isRequired,
};
